import React, { useEffect, useRef, useState } from "react";
import L1 from "../../../assets/inventory-logo-removebg.png";
import L2 from "../../../assets/event-logo.jpeg";
import L3 from "../../../assets/shriramHomeDecorLogo.jpeg";
import L4 from "../../../assets/UforceLogo.jpeg";
import L5 from "../../../assets/AxiaLogo.jpeg";
import L6 from "../../../assets/MobileumLogo.jpeg";
import L7 from "../../../assets/aquariushomesLogo.png"

const logos = [
  { name: "Aquarius Homes", img: L7, link: "https://aquariushomes.in/" },
  { name: "Inventory", img: L1, link: "https://jinraitech.com/inventory/login" },
  { name: "Event Agious Town", img: L2, link: "https://theeventagioustown.com/" },
  { name: "Shriram Home Decor", img: L3, link: "https://shriramhomedecor.com/" },
  { name: "Uforce Foundation", img: L4, link: "https://uforcefoundation.com/" },
  { name: "Axia", img: L5, link: "#" },
  { name: "Mobileum", img: L6, link: "#" },
];

export default function LogoCarousel() {
  const containerRef = useRef(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    let animationFrameId;
    const speed = 0.5; // pixels per frame

    const step = () => {
      setOffset((prev) => {
        const container = containerRef.current;
        const totalWidth = container.scrollWidth / 2;
        const nextOffset = prev - speed;
        return nextOffset <= -totalWidth ? 0 : nextOffset;
      });

      animationFrameId = requestAnimationFrame(step);
    };

    animationFrameId = requestAnimationFrame(step);

    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  return (
    <div className="w-full overflow-hidden bg-white p-8 pt-16 pb-20">
      <h2 className="my-2 md:text-4xl text-3xl text-[--bg-color] font-bold text-center ">
        Our Clients
      </h2>
      <div className="flex justify-center mb-10">
        <div className="w-[140px] border-b-4 border-[--bg-color] mb-8"></div>
      </div>
      <div
        ref={containerRef}
        className="flex flex-row items-center justify-center w-max"
        style={{
          transform: `translateX(${offset}px)`,
          transition: "transform 0.1s linear",
        }}
      >
        {[...logos, ...logos].map((logo, index) => (
          <a
            key={index}
            href={logo.link}
            target="_blank"
            rel="noopener noreferrer"
            className="mx-8 flex-shrink-0"
          >
            <img
              src={logo.img}
              alt={logo.name}
              className="w-40 h-40 object-contain transition-transform duration-300 transform hover:scale-105 rounded-full bg-white border border-gray-300 p-2"
            />
          </a>
        ))}
      </div>
    </div>
  );
}
